import { ClassNameValue } from "tailwind-merge";
import { ImmunizationSeries } from "../models/Interfaces";
import { IzProvider, TRANSLATION_STATUS_LABEL } from "../models/providers/IzProviders";

export const getStatusLabel = (
  izProvider: IzProvider,
  status: string,
  series: ImmunizationSeries
): TRANSLATION_STATUS_LABEL => {
  if (status === "overdue") {
    return izProvider.statusImages.overdueLabel;
  } else if (status === "due_now") {
    return izProvider.statusImages.dueNowLabel;
  } else if (status === "current") {
    return izProvider.statusImages.currentLabel;
  } else if (status === "complete") {
    return izProvider.statusImages.completeLabel;
  } else if (status === "immune") {
    return izProvider.statusImages.immuneLabel;
  } else {
    if (izProvider.statusImages.useNoRecordImage && series.events.length === 0) {
      return izProvider.statusImages.noRecordLabel;
    }
    return izProvider.statusImages.recordLabel;
  }
};

export const getStatusColor = (
  izProvider: IzProvider,
  status: string,
  series: ImmunizationSeries
) => {
  // Default is just a 'record'.
  let className = "bg-status-record";

  if (status === "overdue") {
    className = "bg-status-overdue";
  } else if (status === "due_now" || status === "due") {
    className = izProvider.statusImages.redOnDue ? "bg-status-overdue" : "bg-status-due-or-update";
  } else if (status === "current") {
    className = "bg-status-current";
  } else if (status === "complete") {
    className = "bg-status-current";
  } else if (status === "immune") {
    className = "bg-status-immune";
  } else if (izProvider.statusImages.useNoRecordImage && series.events.length === 0) {
    className = "bg-status-no-records";
  }

  return className;
};
